import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="logo">
        {/* <img src="./Images/JALS.png" alt="Logo" width="60" height="70"/> */}
        
        <span className="bold-text under-text"><u>JALM</u></span>
        <p className="subtitle">Easy Tools</p>
      </div>

      <div className="hamburger" onClick={toggleMobileMenu}>
        <span className={isMobileMenuOpen ? 'bar open' : 'bar'}></span>
        <span className={isMobileMenuOpen ? 'bar open' : 'bar'}></span>
        <span className={isMobileMenuOpen ? 'bar open' : 'bar'}></span>
      </div>

      <ul className={isMobileMenuOpen ? 'nav-links mobile' : 'nav-links'}>
        <li><Link to="https://jalm.in" onClick={toggleMobileMenu}>Home</Link></li>
         <li><Link to="/DateDifference" onClick={toggleMobileMenu}>Date Difference Details</Link></li>
          <li><Link to="/RecordTime" onClick={toggleMobileMenu}>Record Time</Link></li>
        {/* <li><Link to="/SignIn" onClick={toggleMobileMenu}>Sign In</Link></li>
        <li><Link to="/SignUp" onClick={toggleMobileMenu}>Sign Up</Link></li> */}
        <li><Link to="/AboutUs" onClick={toggleMobileMenu}>About Us</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
